// import { PriceManagement } from './old_SupplyDirectory/PriceManagement'

import { EditOutageDrawer } from './components/EditOutageDrawer'
import { SupplyManagementProvider } from './contexts/SupplyManagementContext'
import { Outages } from './Outages/page'
import { SupplyDirectory } from './SupplyDirectory/page'
import { MultiTabGrid } from '../_SiteWide/Layout/MultiTabGrid'

export function SupplyManagement() {
  const tabs = [
    {
      defaultActive: true,
      title: 'Supply',
      description: 'View supply directory.',
      component: <SupplyDirectory />,
    },
    {
      title: 'Outages',
      description: 'View supply outages.',
      component: <Outages />,
    },
  ]
  return (
    <SupplyManagementProvider>
      <MultiTabGrid tabs={tabs} stickStorageKey='supply-management-page' />
      <EditOutageDrawer />
    </SupplyManagementProvider>
  )
  // return <PriceManagement />
}
